module.exports = ".logo-image {\n  cursor: pointer;\n}\n\n.logo-image:hover {\n  opacity: 0.7;\n}\n\n#fileUploadTitle {\n  position: absolute;\n  left: 0;\n  top: 100px;\n  width: 100%;\n  text-align: center;\n  color: gray;\n}\n\nform {\n  width: 300px;\n  height: 200px;\n  border: 4px dashed gray;\n}\n\nform input {\n  content: attr(data-title);\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  outline: none;\n  opacity: 0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/components/sidebar/upload-logo/upload-logo.css
// module id = ./src/app/main/components/sidebar/upload-logo/upload-logo.css
// module chunks = main